import { type PluginExtraInfo } from './types';

/**
 * Merges search extra info from multiple sources (plugins and minions).
 * Plugin data takes precedence, minion data is used as fallback or to supplement.
 */
export const mergeSearchExtraInfo = (
	pluginSearchInfo: PluginExtraInfo | null,
	minionSearchInfo: PluginExtraInfo | null,
): PluginExtraInfo | null => {
	// If we have plugin search info, use it (it has more complete data like rawRankedDocumentsInfoMap)
	if (pluginSearchInfo) {
		return pluginSearchInfo;
	}

	// Otherwise, use minion search info
	return minionSearchInfo;
};
